import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconLockStyle0 = gravityIconIndividualCss;

const GravityIconLock = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '1dfade6d7a53ada162a04e41a3c43bf58098726f', color: this.color, size: this.size }, h("svg", { key: '179c729e89ac8c5ee0794fac25096239bba19ea1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '533556585982aae25eecd1d198b29e534f46bc11', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 8H15V6a4 4 0 1 0-8 0v2H4.53a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.53-.5Zm-5.75 5.8v1.69a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V13.8a1.5 1.5 0 1 1 1.5 0ZM13.5 8h-5V6a2.5 2.5 0 1 1 5 0v2Z", fill: "currentColor" }))));
    }
};
GravityIconLock.style = GravityIconLockStyle0;

export { GravityIconLock as gravity_icon_lock };

//# sourceMappingURL=gravity-icon-lock.entry.js.map